import ScreenNav from '../components/ScreenNav';
import Header from '../components/Header';

export default function WhoamiScreen() {
  return (
    <>
      <ScreenNav />
      <Header />
    </>
  );
}
